import React from 'react'

interface VisaIconProps {
    height?: number
    width?: number
}

const VisaIcon: React.FC<VisaIconProps> = ({ height, width }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill='none'
            viewBox='0 0 18 18'
        >
            <path
                d='M9.00033 17.3332C4.39795 17.3332 0.666992 13.6022 0.666992 8.99984C0.666992 4.39746 4.39795 0.666504 9.00033 0.666504C13.6027 0.666504 17.3337 4.39746 17.3337 8.99984C17.3337 13.6022 13.6027 17.3332 9.00033 17.3332ZM7.09201 15.3893C6.28985 13.6881 5.79809 11.8117 5.68975 9.83317H2.38523C2.71533 12.4803 4.59732 14.6454 7.09201 15.3893ZM7.35924 9.83317C7.48458 11.8655 8.06516 13.7746 9.00033 15.4598C9.93549 13.7746 10.5161 11.8655 10.6414 9.83317H7.35924ZM15.6154 9.83317H12.3109C12.2026 11.8117 11.7108 13.6881 10.9087 15.3893C13.4033 14.6454 15.2853 12.4803 15.6154 9.83317ZM2.38523 8.1665H5.68975C5.79809 6.18798 6.28985 4.31156 7.09201 2.6103C4.59732 3.35428 2.71533 5.51942 2.38523 8.1665ZM7.35924 8.1665H10.6414C10.5161 6.13419 9.93549 4.22505 9.00033 2.53983C8.06516 4.22505 7.48458 6.13419 7.35924 8.1665ZM10.9087 2.6103C11.7108 4.31156 12.2026 6.18798 12.3109 8.1665H15.6154C15.2853 5.51942 13.4033 3.35428 10.9087 2.6103Z'
                fill='currentColor'
                fillRule='evenodd'
            />
        </svg>
    )
}

VisaIcon.defaultProps = {
    height: 20,
    width: 20
}

export default VisaIcon
